module.exports = __webpack_public_path__ + "static/media/OM.64825d13.svg";